// MTV-577: removed files StreamPlaylistAbstract, CreatePlaylistAbstract, CreateChannelPlaylist, CreateContentPlaylist, CretateRollingBufferPlaylist  
import { ErrorBase } from "store/ErrorBase"
import { moment } from "store/util/moment"
import { flow, runInAction } from "mobx"
//import { MicroServiceError } from "store/qlapi/MicroServiceError"
import { rootStore } from "store/RootStore"
import { TimeoutError } from "store/qlapi/TimeoutError"
import { timeNow, sleep } from "utils/Utils"
import { EventEmitter } from "components/utils/EventEmitter"
import { TIME_FORMAT_BACKEND } from "store/model/Time"
import { Mutex } from 'async-mutex'
import { l10n } from "store/lang/L10n"
import { getQlHeaders } from "store/qlapi/QlHeaders"

import { getCoCoModule, CoCoError } from "store/page/repo/CoCoModule"
const CoCo = await getCoCoModule()

export class StreamPlayList {
	// TODO joachim: add example MediaService reply
	// json structure returned from MediaLookupService
	StreamInfo = null
	// ID for the stream
	StreamID = null
	// set by MediaLookupService
	mediaService = null
	// MTVW-788, MTVW-787: sessionIdsMap, savedSession, mutex
	static sessionIdsMap = new Map()
	static savedSessions = []	// empty array for inital cleanupSessions, later null
	// MTVW-795: mutex for proper synchronization and session / keep alive handling
	static mutex = new Mutex()
	// MTVW-795
	static startup = true
	player = null
	// interval timer id, only 1 active stream
	// MTVW-788, MTVW-787: not static anymore
	_keepAliveId = null
	// MTVW-589: background timer to check renew delegation (in case we get control in the background again),
	// it's not guaranteed that it will be always called
	// MTVW-788, MTVW-787: not static anymore
	_bgCheckerId = null
	// MTVW-613: global for proper removal of event listener
	// MTVW-788, MTVW-787: not static anymore
	boundVisibilityHandler = null
	// MTVW-613: global
	currentVisibility = "visible" //document.visibilityState
	lastRenewal = null

	// MTVW-725
	validTimeoutId = null

	constructor(parent, path) {
		//console.debug("%s: new StreamPlayList", timeNow(), parent, path, this)
		// MTVW-613: Stop keepalive for previous stream in any case, handled in startKeepAlive()
		//this._keepAliveId = null
		//this._bgCheckerId = null
		//console.trace("%s --sessionMgmt new StreamPlayList", timeNow(), this)
	}

	static {
		window.addEventListener('beforeunload', (event) => {
			//event.preventDefault()
			// We can't do much in 'beforeunload' event, asynchronously deleting sessison, wouldn't work,
			// therefore save the sessions in the session storage, so that they can be deleted after the browser is reloaded
			const sessions = []
			StreamPlayList.sessionIdsMap?.forEach((value, key) => {
				//console.debug("beforeUnload val %o, key %o", value.streamPlayList.sessionId, key)
				sessions.push(value.streamPlayList.sessionId)
			})
			sessionStorage.setItem("autosave", JSON.stringify(sessions))
		})

		// check if we have saved sessions that should be deleted
		StreamPlayList.savedSessions = JSON.parse(sessionStorage.getItem("autosave"))
	}

	//setStreamInfo(streamInfo, streamID, mediaService, player) {
	setStreamInfo = flow(function* (streamInfo, streamID, mediaService, player) {
		this.StreamInfo = streamInfo
		// MTVW-1105: temporary additional output for bdd logs
		console.warn("licenseUrl GOT %o, deviceId %s", streamInfo, getQlHeaders()?.['X-Quickline-Deviceid'])
		this.StreamID = streamID
		this.mediaService = mediaService
		if (!player._refElemContainer || !player.idDomPlayer || !player.idDomElement) {
			console.warn("--sessionMgmt setStreamInfo", player.idDomPlayer, player.idDomElement, player.__path)
			// MTVW-996: It can happen when switching quickly at startup from the Discover to the LiveTv page
			return
		}
		// MTVW-788, MTVW-787: sessionIdsMap
		this.player = player
		let release = null
		try {
			console.debug("%s --sessionMgmt setStreamInfo start", timeNow(), this.sessionId)
			// MTVW-795: Use sessionId instead of player.__path
			// MTVW-1157: acquire mutex BEFORE cleanupSessions so concurrent setStreamInfo calls
			// can't both see startup===true and race on deleting/registering the same sessions

			release = yield StreamPlayList.mutex.acquire()
			// session cleanup if the app is started
			yield this.cleanupSessions()

			if (StreamPlayList.sessionIdsMap.has(this.sessionId)) {
				const info = StreamPlayList.sessionIdsMap.get(this.sessionId)
				console.warn("%s --sessionMgmt sessionId exists", timeNow(), this.sessionId, info, info.streamPlayList.sessionId, info.streamPlayList._keepAliveId)
				clearInterval(info.streamPlayList._keepAliveId)
				StreamPlayList.sessionIdsMap.delete(info.streamPlayList.sessionId)
			}
			console.debug("%s --sessionMgmt set", timeNow(), this.sessionId)
			StreamPlayList.sessionIdsMap.set(this.sessionId, {
				streamPlayList: this,
			})
		}
		finally {
			// release Mutex
			console.debug("%s --sessionMgmt setStreamInfo end", timeNow(), this.sessionId, StreamPlayList.sessionIdsMap, this.player?.__path)
			if (release) release()
		}
	})

	get getStreamId() {
		if (this.StreamID) {
			return this.StreamID
		}
		throw ErrorBase.CreateError(["system"], null, this, "stream")
	}

	get getStreamUrl() {
		if (this.StreamInfo) {
			console.info("StreamPlayList.getStreamUrl: type=%o begin=%o eventStart=%o", this.eventType, this.begin, this.eventStart)

			// TODO also check for "live-replay" type?
			if (this.seekable || !this.eventStart) {
				return this.StreamInfo.streamUrl
			}
		}
		throw ErrorBase.CreateError(["system"], null, this, "stream")
	}

	get _offset() {
		//return (this.StreamInfo.rstv?.time_offset || 0)
		// TOCHECK case play recording when not yet finished. Should we return 1 in this case, otherwise 0?
		let result = this.StreamInfo.bufferStart ? moment(this.StreamInfo.bufferStart).valueOf() : 0
		return result
	}

	get begin() {
		//return this._offset + (this.StreamInfo.rstv?.begin || 0)
		// MTVW-543
		let result = this.StreamInfo.bufferStart ? moment(this.StreamInfo.bufferStart).valueOf() : 0
		// MTVW-648: workaround, bufferStart should be < eventStart
		if (result >= this.eventStart) result = this.eventStart - 200
		return result
	}

	get end() {
		//return this._offset + (this.StreamInfo.rstv?.end || 0)
		// MTVW-543
		return this.StreamInfo.bufferEnd ? moment(this.StreamInfo.bufferEnd).valueOf() : 0
	}

	get seekable() {
		//return this.StreamInfo.rstv?.seekable || false
		return this.streamType !== "live"
	}

	get eventStart() {
		// this property applies positioning after disconnect / background state
		//return this.begin + (this.StreamInfo.rstv?.event_offset || 0)
		// MTVW-543
		let result = this.StreamInfo.eventStart ? moment(this.StreamInfo.eventStart).valueOf() : 0
		//console.debug("result = %o, streamInfo %o", result, this.StreamInfo)

		// TODO: It makes sense to use eventPrefix in recordings since it's not guaranteed that
		// bufferStart corresponds to eventStart - eventPrefix.
		if (this.streamType === "recording" && result > 0) {
			if (result - moment(this.StreamInfo.bufferStart).unix() === moment.duration(this.StreamInfo.eventPrefix).asSeconds()) {
				// initial (minus) position with eventPrefix active
				result = 0
			}
			//console.debug("recording offset %s", result - moment(this.StreamInfo.bufferStart).valueOf())
		}
		return result
	}

	get streamType() {
		return this.StreamInfo?.eventType
	}

	get keepAliveUrl() {
		return this.StreamInfo?.keepAliveUrl
	}

	get keepAliveInterval() {
		let interval = moment.duration(this.StreamInfo.keepAliveInterval).seconds()
		return interval > 0 ? interval : 20
	}

	get sessionId() {
		return this.StreamInfo?.sessionId
	}

	// MTVW-578 PoC
	get getDrmScheme() {
		if (this.StreamInfo) {
			console.debug("playlist drmScheme", this.StreamInfo?.drmScheme)
			return this.StreamInfo?.drmScheme
		}
		throw ErrorBase.CreateError(["system"], null, this, "stream")
	}

	get getStreamUrlLicense() {
		if (this.StreamInfo) {
			// MTVW-1105: temporary warn output for bdd logs
			console.warn("playlist licenseUrl", this.StreamInfo?.keyRequestUrl)
			return this.StreamInfo?.keyRequestUrl
		}
		throw ErrorBase.CreateError(["system"], null, this, "stream")
	}

	get getStreamUrlCertificate() {
		if (this.StreamInfo) {
			console.debug("playlist streamUrlCertificate", this.StreamInfo?.certUrl)
			return this.StreamInfo?.certUrl
		}
		throw ErrorBase.CreateError(["system"], null, this, "stream")
	}

	// MTVW-725
	get validTillDuration() {
		const till = this.StreamInfo.validTill ? moment(this.StreamInfo.validTill).utc().valueOf() : 0
		const duration = till - moment().utc().valueOf()
		console.debug("validTill: %s, now: %s, %s sec", moment(till).utc().format(TIME_FORMAT_BACKEND), moment().utc().format(TIME_FORMAT_BACKEND), duration / 1000)
		return duration
	}

	_playerError = (error) => {
		console.debug("%s: --sessionMgmt _playerError", timeNow(), this.sessionId, this._keepAliveId, this._bgCheckerId, error)
		if (this._bgCheckerId) {
			this._handleKeepAliveError(new TimeoutError())
		}
	}

	//_wakeup(event) { //= flow(function* (event) {
	// Use arrow function for proper this binding. Using the bind method would result in 'native' code
	// and EventEmitter.release can not detect if the function is already subscribed
	_wakeup = (event = "interval") => {
		const DELEGATION_DURATION = 30 * 60000
		console.debug("%s: WAKEUP event", timeNow(), event, this, this.currentVisibility, this._bgCheckerId)
		if (this.mediaService && this.currentVisibility !== "visible" && this._bgCheckerId) {
			// check for expired time
			const now = moment().valueOf()
			console.debug("%s: lastRenewal", timeNow(), this.lastRenewal)
			if (this.lastRenewal) console.debug("diff _renewKeepAliveDelegation", now - this.lastRenewal)
			if (this.lastRenewal && (now - this.lastRenewal) > DELEGATION_DURATION) {
				console.debug("%s --sessionMgmt elapsed=", timeNow(), this.sessionId, now - this.lastRenewal, now, this.lastRenewal)
				this._handleKeepAliveError(new TimeoutError())
			}
			else {
				this.lastRenewal = now
				//console.debug("calling _renewKeepAliveDelegation", this.sessionId)
				this._renewKeepAliveDelegation(this.sessionId).catch((err) => {
					console.debug("%s --sessionMgmt _renewKeepAliveDelegation=", timeNow(), this.sessionId)
					this._handleKeepAliveError(err)
					//console.error("CAUGHT in setInterval", err)
					// error handling
				})
			}
		}
	}

	// MTVW-577
	delegationState = flow(function* (sessionId) {
		// check error 2x put true,
		// getSessions no sessions,
		// visibilitychange SUSPEND DELEGATION: (delete session or keepAliveDelegation) session not found
		let isDelegated = false
		let isInSessions = false
		if (this.mediaService && this.keepAliveUrl && this.keepAliveInterval && sessionId) {
			const sessions = yield this.mediaService.getSessions()
			console.debug("delegationState", sessions)
			//console.debug("Number of streaming sessions", sessions?.length)
			return this.isInMsSessions(sessionId, sessions)
		}
		return [isDelegated, isInSessions]
	})

	// MTVW-633
	// MTVW-1157: add guard
	_isHandlingKeepAliveError = false

	_handleKeepAliveError = flow(function* (error) {
		// guard against concurrent/duplicate invocations from _playerError, _wakeup,
		// and visibilityChange firing around the same time
		if (this._isHandlingKeepAliveError) {
			console.debug("%s: --sessionMgmt _handleKeepAliveError already in progress, skipping", timeNow(), this.sessionId)
			return
		}
		this._isHandlingKeepAliveError = true
		try {
			const [isDelegated, isInSessions] = yield this.delegationState(this.sessionId)
			console.error("%s: --sessionMgmt _handleKeepAliveError %s, %s, %s, %o", timeNow(), this.sessionId, this._keepAliveId, isDelegated, isInSessions, error)
			if (isDelegated) {
				console.debug("%s, STOPPING keepAliveDelegation", timeNow())
				yield this.mediaService?.keepAliveDelegation(this.sessionId, false)
			}
		}
		catch (e) {
			console.error("%s, CAUGHT in _handleKeepAliveError", timeNow(), e)
		}
		finally {
			try {
				const isMapEntry = StreamPlayList.sessionIdsMap.has(this.sessionId)
				//yield this.stopKeepAlive()
				yield this.player?.stopInstance()
				// MTVW-795
				yield this.deleteAllSessions()

				// in case there was no entry in sessionIdsMap anymore
				/*
				if (!isMapEntry) {
					console.warn("_handleKeepAliveError no map entry")
					clearInterval(this._keepAliveId)
					this._keepAliveId = null
					clearInterval(this._bgCheckerId)
					this._bgCheckerId = null
					yield this.deleteSession(this.sessionId)
				}
				*/
			}
			catch (e) {
				console.error("%s: stopKeepAlive failed", timeNow(), e)
			}
			// CreateError(["system"], null, this, "stream")
			//throw ErrorBase.CreateError(["player", "CB_ERROR", msg], null, { code: error.code, type: error.type })
			runInAction(() => {
				let internal = (error instanceof TimeoutError) ? "" : (typeof error?.internal === "string" && !error.internal.includes("unknown")) ? error.internal : ""
				// MTVW-1096: internal could be for instance CoCo throttling error (string)
				if (internal.includes("html")) {
					internal = error.httpStatusCode
				}
				if (internal !== "") internal = ": " + internal
				//debugger
				if (this.player?.errorCallback) this.player.errorCallback(internal)
				else rootStore.page.Player.error = ErrorBase.CreateError([l10n.featurePlayerErrorSleepMessageWeb + internal], null, this, "stream")
			})
			this.lastRenewal = null
			EventEmitter.release("wakeup", this._wakeup)
			EventEmitter.release("playerError", this._playerError)
			this._isHandlingKeepAliveError = false
		}
	})

	// MTVW-577
	_renewKeepAliveDelegation = flow(function* (sessionId) {
		//try {
		// In case delegation is already active, we need to stop and start it again
		const [isDelegated, isInSessions] = yield this.delegationState(sessionId)
		console.debug("%s: RENEW DELEGATION delegated %s, inSession,%s, sessionId %s", timeNow(), isDelegated, isInSessions, sessionId)
		if (isDelegated) yield this.mediaService?.keepAliveDelegation(sessionId, false)
		//console.debug("keepAliveDelegation", this.sessionId)
		yield sleep(500)
		if (isInSessions) yield this.mediaService?.keepAliveDelegation(sessionId, true)
		// MTVW-633: debug output
		console.debug("%s: renew done", timeNow())
		yield rootStore.sso.profile.refreshTokens()
		//}
		/*
		catch (e) {
			console.error("_renewKeepAliveDelegation", e)
			//throw e
			runInAction(() => {
				rootStore.page.Player.error = e
			})
			rootStore.page.Player?.player?.setRefElemContainer?.(null)
		}
		return result
		*/
	})

	// MTVW-577
	visibilityChange = flow(function* () {
		//console.debug("visibilityChange", this.player?.__path)
		if (this.player?.__path === "playerDiscover") return
		const visibilityState = document.visibilityState
		//console.debug("%s: StreamPlayList visibility %s", timeNow(), visibilityState, this.currentVisibility, this.sessionId)
		if (!this.boundVisibilityHandler || !this._keepAliveId) return
		// occasionaly multiple events with same visibilityState
		if (this.currentVisibility === visibilityState) return
		this.currentVisibility = visibilityState
		console.debug("%s: StreamPlayList visibility %s", timeNow(), visibilityState, this.currentVisibility, this.sessionId, this.StreamInfo)
		try {
			if (this.mediaService && this.keepAliveUrl && this.keepAliveInterval && this.sessionId) {
				if (rootStore.page.Player.playerFg && import.meta.env.VITE_DISPOSE_LIVE_PLAYER === "true") {
					// don't delegate keep alive for foreground player, to avoid 'keep alive delegation is already enabled' error
					if (this.sessionId === rootStore.page.Player.playerFg?._source?.playlist?.StreamInfo?.sessionId) {
						console.debug("no keep alive delegation!")
						return
					}
				}
				if (visibilityState !== "visible") {
					//console.debug("subscribing", this._wakeup)
					EventEmitter.release("wakeup", this._wakeup)
					EventEmitter.subscribe("wakeup", this._wakeup)
					EventEmitter.release("playerError", this._playerError)
					EventEmitter.subscribe("playerError", this._playerError)
					// activate background keep alive delegation
					//console.debug("START BG TIMER")
					yield this._renewKeepAliveDelegation(this.sessionId)

					// MTVW-589: background checker timer
					clearInterval(this._bgCheckerId)
					// performance.now() is not accurate during sleep
					this.lastRenewal = moment().valueOf()
					const INTERVAL = 5 * 60000 // 5 minutes
					const DELEGATION_DURATION = 30 * 60000 // 30 minutes
					this._bgCheckerId = setInterval(this._wakeup, INTERVAL)
				}
				else {
					yield rootStore.sso.profile.refreshTokens()
					// MTVW-589: background checker timer
					clearInterval(this._bgCheckerId)
					this._bgCheckerId = null
					// dactivate background keep alive delegation
					console.debug("%s: SUSPEND DELEGATION", timeNow())
					yield this.mediaService.keepAliveDelegation(this.sessionId, false)
					// trigger keepalive
					yield this.mediaService.keepAlive(this.keepAliveUrl)
					EventEmitter.release("wakeup", this._wakeup)
					EventEmitter.release("playerError", this._playerError)
					console.debug("hidden isPaused", rootStore.page.Player, rootStore.page.Player.player.isPaused)
					// MTVW-683, MTVW-685: Fix condition
					if (!rootStore.page.Player.player.isPaused) yield rootStore.page.Player.player.setPlay("visibilityChange")
				}
			}
		}
		catch (e) {
			console.error("%s: visibilityChange", timeNow(), e)
			yield this._handleKeepAliveError(e)
		}
	})

	execKeepAlive = flow(function* (updateBookmark) {
		// MTV-3180: avoid sporadic TypeError (mediaService === null)
		// MTVW-577: visibilityState
		console.debug("%s: --sessionMgmt execKeepAlive", timeNow(), this.sessionId)
		// MTVW-951: mutex to avoid race condition, check for StreamPlayList.sessionIdsMap.has(this.sessionId)
		const release = yield StreamPlayList.mutex.acquire()
		try {
			// re-check _keepAliveId now that we hold the lock — it may have been cleared
			// by a concurrent stopKeepAlive/deleteSession between the caller's setInterval
			// firing and us acquiring the mutex
			if (!this._keepAliveId) {
				console.warn("%s: --sessionMgmt execKeepAlive cleared before lock", timeNow(), this.sessionId)
				return // finally will be executed to release the mutex
			}
			// testing purpose
			//CoCo.throwClientError()
			//throw new TimeoutError()
			if (this.mediaService && StreamPlayList.sessionIdsMap.has(this.sessionId)) {
				console.debug("%s: --sessionMgmt refresh keepAlive", timeNow(), this.sessionId, this._keepAliveId, this.player?.__path, this.keepAliveUrl)
				try {
					if (!this._bgCheckerId) yield this.mediaService.keepAlive(this.keepAliveUrl)
					// MTVW-816
					console.debug("invoking playbackProgress", updateBookmark)
					//if (updateBookmark) yield rootStore.page.CoCoBookmarks.setBookmarkAsync(this.player, this.player.positionTimeStamp)
					if (updateBookmark && this.player?.openStreamDone) yield rootStore.page.CoCoBookmarks.playbackProgress(this.player, this.player.positionTimeStamp)
				}
				catch (err) {
					console.error("%s: --sessionMgmt refresh keepAlive", timeNow(), this.sessionId, this._keepAliveId)
					this._handleKeepAliveError(err)
				}
			}
			else {
				console.warn("%s: --sessionMgmt execKeepAlive clear", timeNow(), this.sessionId, this._keepAliveId)
				clearInterval(this._keepAliveId)
				this._keepAliveId = null
			}
		}
		catch (e) {
			console.error("%s: --sessionMgmt execKeepAlive end", timeNow(), this.sessionId, this._keepAliveId)
		}
		finally {
			//console.debug("%s: --sessionMgmt execKeepAlive done", timeNow(), this.sessionId, this._keepAliveId, this.player?.__path, this.keepAliveUrl)
			if (release) release()
		}
	})

	// MTVW-577: keep alive delegation
	startKeepAlive = flow(function* () {
		// MTVW-725
		clearInterval(this.validTimeoutId)
		//console.debug("till: %s ms", this.validTillDuration, this, this.player?._source)
		if (this.validTillDuration > 0) {
			// use setInterval instead of setTimeout to improve accuracy in case of background activation
			// clearInterval
			this.validTimeoutId = setInterval(() => {
				// safety margin of 1 minute
				if (this.validTillDuration <= 60000) {
					if (!this.player.__parent.isAdsPlayer) this.player._source?.videoSnapshot()
					this.player?.setIsPosterVisible(true, "validTill", false)
					clearInterval(this.validTimeoutId)
					this.validTimeoutId = null
					this.player?._isInactive("validTill")
					setTimeout(() => {
						this.player?._isActive("validTill")
					}, 200)
				}
			}, 60000)
		}
		clearInterval(this._keepAliveId)
		this._keepAliveId = null
		clearInterval(this._bgCheckerId)
		this._bgCheckerId = null
		this.currentVisibility = "visible" //document.visibilityState
		if (this.mediaService && this.keepAliveUrl && this.keepAliveInterval) {
			// MTVW-788, MTVW-787: do not delete other sessions
			//this.deleteInactiveSessions(this.sessionId)
			// do initial keepAlive, argument currently true for updateBookmark
			// MTVW-951: rely on timer
			//yield this.execKeepAlive(true)
			this._keepAliveId = setInterval(() => {
				// bind would generate: Uncaught TypeError: this.execKeepAlive(...).bind is not a function
				this.execKeepAlive(true)//.bind(this)
			}, this.keepAliveInterval * 1000)
		}
		console.debug("%s --sessionMgmt startKeepAlive %s", timeNow(), this.sessionId, this._keepAliveId, this.player?.__path, this.player?._source)

		if (this.boundVisibilityHandler) {
			console.debug("%s --sessionMgmt remove boundVisibilityHandler", timeNow())
			document.removeEventListener('visibilitychange', this.boundVisibilityHandler)
		}
		this.boundVisibilityHandler = this.visibilityChange.bind(this)
		document.addEventListener('visibilitychange', this.boundVisibilityHandler)
		//console.debug("%s --sessionMgmt addEventListener boundVisibilityHandler", timeNow())

		// for a given player there should be only 1 session, check and delete any older sessions(s)
		yield this.deleteInactiveSessions(this.sessionId, this.player?.__path)

		// live pause case, the browser could have switched into the background
		if (document.visibilityState === "hidden") {
			console.warn("visibilitychange HIDDEN!")
			// check keep alive delegation state
			/* TODO recheck
			const sessions = yield this.mediaService.getSessions()
			for (let i = 0; i < sessions?.length; i++) {
				if (sessions[i]?.keepAliveDelegation) {
					try {
						yield this.mediaService.keepAliveDelegation(sessions[i]?.sessionId, false)
					}
					catch (e) {
						console.error("%s: delegationState", timeNow(), e)
					}
				}
			}
			*/
			yield this.visibilityChange()
		}
	})

	// MTVW-795
	isInMsSessions(sessionId, msSessions) {
		let isDelegated = false
		let isInSessions = false
		//console.debug("Number of streaming sessions", sessions?.length)
		for (let i = 0; i < msSessions?.length; i++) {
			try {
				if (msSessions[i]?.sessionId === sessionId) {
					isInSessions = true
					if (msSessions[i]?.keepAliveDelegation) isDelegated = true
					break
				}
			}
			catch (e) {
				console.error("%s: isInMsSessions", timeNow(), e)
			}
		}
		return [isDelegated, isInSessions]
	}

	// MTVW-787, MTVW-788
	deleteSession = flow(function* (sessionId, msSessions, locked = false) {
		console.debug("%s --sessionMgmt deleteSession", timeNow(), sessionId, this.mediaService)
		if (this.mediaService) {
			let release = null
			if (!locked) release = yield StreamPlayList.mutex.acquire()
			try {
				if (StreamPlayList.sessionIdsMap.has(sessionId)) {
					const info = StreamPlayList.sessionIdsMap.get(sessionId)
					//console.debug("%s --sessionMgmt deleteSession boundVisibilityHandler", timeNow(), info.streamPlayList.boundVisibilityHandler, sessionId, this.sessionId, info)
					if (info.streamPlayList.boundVisibilityHandler) document.removeEventListener('visibilitychange', info.streamPlayList.boundVisibilityHandler)
					info.streamPlayList.boundVisibilityHandler = null
					info.streamPlayList.currentVisibility = document.visibilityState
					console.debug("%s --sessionMgmt clearInterval", timeNow(), sessionId, info.streamPlayList._keepAliveId)
					clearInterval(info.streamPlayList._keepAliveId)
					info.streamPlayList._keepAliveId = null
					clearInterval(info.streamPlayList._bgCheckerId)
					info.streamPlayList._bgCheckerId = null
				}
				else console.warn("%s --sessionMgmt deleteSession not in map", timeNow(), sessionId)
				StreamPlayList.sessionIdsMap.delete(sessionId)

				const [isDelegated, isInSessions] = this.isInMsSessions(sessionId, msSessions)
				if (isInSessions) yield this.mediaService.deleteSession(sessionId)
				else console.warn("session %s not in msSessions", sessionId)
			}
			catch (e) {
				console.error("%s: deleteSession %s, %o, %o", timeNow(), sessionId, e)
			}
			finally {
				if (release) release()
			}
		}
	})

	// MTVW-795
	deleteAllSessions = flow(function* () {
		const sessions = yield this.mediaService.getSessions()
		for (let i = 0; i < sessions?.length; i++) {
			const sessionId = sessions[i]?.sessionId
			console.debug("deleteAllSessions", sessionId)
			yield this.deleteSession(sessionId, sessions)
		}

		// check if there is any remaining entry in the map
		StreamPlayList.sessionIdsMap?.forEach((value, key) => {
			if (value.streamPlayList.boundVisibilityHandler) document.removeEventListener('visibilitychange', value.streamPlayList.boundVisibilityHandler)
			value.streamPlayList.boundVisibilityHandler = null
			value.streamPlayList.currentVisibility = document.visibilityState
			clearInterval(value.streamPlayList._keepAliveId)
			value.streamPlayList._keepAliveId = null
			clearInterval(value.streamPlayList._bgCheckerId)
			value.streamPlayList._bgCheckerId = null
		})
		StreamPlayList.sessionIdsMap.clear()
	})

	// MTVW-787, MTVW-788	
	cleanupSessions = flow(function* () {
		try {
			const sessions = yield this.mediaService.getSessions()
			console.debug("cleanupSessions media %s, %o, sessionIdsMap %s, %o", sessions?.length, sessions, StreamPlayList.sessionIdsMap.size, StreamPlayList.sessionIdsMap)
			// savedSessions might exist if the app has been reloaded. If the browser has been quit do the cleanup on startup.
			if (StreamPlayList.startup || StreamPlayList.savedSessions) {
				console.debug("cleanupSessions savedSessions", StreamPlayList.savedSessions, StreamPlayList.savedSessions?.length)
				for (let i = 0; i < sessions?.length; i++) {
					try {
						const sessionId = sessions[i]?.sessionId
						if ((StreamPlayList.startup && this.sessionId !== sessionId) ||
							(StreamPlayList.savedSessions?.length > 0 && StreamPlayList.savedSessions.includes(sessionId))) {
							console.debug("cleanupSessions delete", sessions[i]?.sessionId)
							yield this.mediaService.deleteSession(sessions[i].sessionId)
						}
					}
					catch (e) {
						console.error("%s: cleanupSessions %s, %o, %o", timeNow(), sessions[i].sessionId, sessions, e)
					}
				}
				StreamPlayList.savedSessions = null
				StreamPlayList.startup = false
			}
		}
		catch (err) {
			console.error("cleanupSessions", err)
		}
	})

	// MTVW-589
	deleteInactiveSessions = flow(function* (sessionToKeep, playerPath) {
		if (this.mediaService) {
			const oldSessions = []
			console.debug("%s --sessionMgmt deleteInactiveSessions start", timeNow(), sessionToKeep, playerPath, StreamPlayList.sessionIdsMap.size, StreamPlayList.sessionIdsMap)
			StreamPlayList.sessionIdsMap?.forEach((value, key) => {
				console.debug("%s --sessionMgmt deleteInactiveSessions entry", timeNow(), value.streamPlayList.sessionId, value.streamPlayList.player.__path)
				if (value.streamPlayList.sessionId !== sessionToKeep &&
					value.streamPlayList.player.__path === playerPath) oldSessions.push(value.streamPlayList.sessionId)
			})
			if (oldSessions.length > 0) console.warn("oldSessions", oldSessions)

			try {
				const sessions = yield this.mediaService.getSessions()
				for (let i = 0; i < sessions?.length; i++) {
					if (oldSessions.includes(sessions[i]?.sessionId)) {
						console.warn("deleteInactiveSessions session", sessions[i].sessionId)
						yield this.deleteSession(sessions[i].sessionId, sessions)
					}
				}
			}
			catch (e) {
				console.error("%s: deleteInactiveSessions getSessions %o", timeNow(), e)
			}
			//console.debug("deleteInactiveSessions end", StreamPlayList.sessionIdsMap.size)
		}
	})

	// MTVW-577: keep alive delegation, called from player when it is killed
	stopKeepAlive = flow(function* () {
		// MTVW-654: prevent concurrent calls, deleteInactiveSessions would generate 404
		let release = yield StreamPlayList.mutex.acquire()
		console.debug("%s --sessionMgmt stopKeepAlive", timeNow(), this.sessionId, StreamPlayList.sessionIdsMap.size, StreamPlayList.sessionIdsMap, StreamPlayList.sessionIdsMap.has(this.sessionId), this.player?.__path)
		try {
			// MTVW-788, MTVW-787: delete specific session
			// MTVW-795: Use sessionId instead of player.__path
			if (StreamPlayList.sessionIdsMap.has(this.sessionId)) {
				const info = StreamPlayList.sessionIdsMap.get(this.sessionId)
				const sessions = yield this.mediaService.getSessions()
				// do not reacquire mutex in deleteSession
				yield info.streamPlayList.deleteSession(this.sessionId, sessions, true)
				// MTVW-725
				/*if (!rootStore.page.Player.playerFg)*/ clearInterval(info.streamPlayList.validTimeoutId)
			}
		}
		catch (e) {
			console.error("stopKeepAlive", e)
		}
		finally {
			//yield this.mediaService.getSessions()
			console.debug("%s --sessionMgmt stopKeepAlive done", timeNow(), StreamPlayList.sessionIdsMap.size, this.player?.__path, StreamPlayList.sessionIdsMap, StreamPlayList.sessionIdsMap.has(this.sessionId))
			StreamPlayList.sessionIdsMap?.forEach((value, key) => {
				console.debug("%s --sessionMgmt stopKeepAlive entry", timeNow(), value.streamPlayList.sessionId, value.streamPlayList.player.__path)
			})
			if (release) release()
		}
	})
}
